// TODO: Uncomment the loaders when the translations are ready
const messagesConfig = [
	// Czech
	{
		locales: ['cs', 'cs-CZ'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_cs_CZ" */ './loaders/cs_CZ'),
	},
	// Danish
	{
		locales: ['da', 'da-DK'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_da_DK" */ './loaders/da_DK'),
	},
	// German
	{
		locales: ['de', 'de-DE'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_de_DE" */ './loaders/de_DE'),
	},
	// Spain
	{
		locales: ['es', 'es-ES'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_es_ES" */ './loaders/es_ES'),
	},
	// Finnish
	{
		locales: ['fi', 'fi-FI'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_fi_FI" */ './loaders/fi_FI'),
	},
	// French
	{
		locales: ['fr', 'fr-FR'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_fr_FR" */ './loaders/fr_FR'),
	},
	// Hungarian
	{
		locales: ['hu', 'hu-HU'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_hu_HU" */ './loaders/hu_HU'),
	},
	// Icelandic
	{
		locales: ['is', 'is-IS'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_is_IS" */ './loaders/is_IS'),
	},
	// Italian
	{
		locales: ['it', 'it-IT'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_it_IT" */ './loaders/it_IT'),
	},
	// Japanese
	{
		locales: ['ja', 'ja-JP'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_ja_JP" */ './loaders/ja_JP'),
	},
	// Korean
	{
		locales: ['ko', 'ko-KR'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_ko_KR" */ './loaders/ko_KR'),
	},
	// Dutch
	{
		locales: ['nl', 'nl-NL'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_nl_NL" */ './loaders/nl_NL'),
	},
	// Norwegian (Norway)
	{
		locales: ['nb', 'nb-NO'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_no_NO" */ './loaders/nb_NO'),
	},
	// Polish
	{
		locales: ['pl', 'pl-PL'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_pl_PL" */ './loaders/pl_PL'),
	},
	// Portuguese -
	{
		locales: ['pt-BR'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_pt_BR" */ './loaders/pt_BR'),
	},
	// Romanian
	{
		locales: ['ro', 'ro-RO'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_ro_RO" */ './loaders/ro_RO'),
	},
	// Russian
	{
		locales: ['ru', 'ru-RU'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_ru_RU" */ './loaders/ru_RU'),
	},
	// Swedish
	{
		locales: ['sv', 'sv-SE'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory_i18n_sv_SE" */ './loaders/sv_SE'),
	},
	// China uses Chinese (Simplified)
	{
		locales: ['zh', 'zh-CN', 'zh-Hans'],
		loader: null,
		// loader: () =>
		// 	import(/* webpackChunkName: "standalone-directory-zh_simplified" */ './loaders/zh_CN'),
	},
	// Taiwan or Hong Kong uses Chinese (Traditional)
	{
		locales: ['zh-TW', 'zh-HK', 'zh-Hant'],
		loader: null,
		// loader: () =>
		// import(/* webpackChunkName: "standalone-directory-zh_traditional" */ './loaders/zh_TW'),
	},
	// Turkish
	{
		locales: ['tr', 'tr-TR'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-tr_TR" */ './loaders/tr_TR'),
	},
	// Thai
	{
		locales: ['th', 'th-TH'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-th_TH" */ './loaders/th_TH'),
	},
	// Ukrainian
	{
		locales: ['uk', 'uk-UA'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-uk_UA" */ './loaders/uk_UA'),
	},
	// Vietnamese
	{
		locales: ['vi', 'vi-VN'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-vi_VN" */ './loaders/vi_VN'),
	},
	// English (UK)
	{
		locales: ['en-GB'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-en_GB" */ './loaders/en_GB'),
	},
	// English (US)
	{
		locales: ['en', 'en-US'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-en_US" */ './loaders/en_US'),
	},
	// English (Instrumented) used by i18n in staging
	{
		locales: ['en-ZZ'],
		loader: null,
		// loader: () => import(/* webpackChunkName: "standalone-directory-en_ZZ" */ './loaders/en_ZZ'),
	},
];

export default messagesConfig;
